import { DataManager, Query } from '@syncfusion/ej2-data';
import { URL } from '../common/constants';
import { ICustomFieldOptions } from '../common/model/customFieldOptions.model';
import * as services from '.';
import { IMyRule } from '../common/model/myRule.model';
import { oDataService, queryBuilderService } from '.';
import { IFile } from '../common/model/responseError.model';

export interface ITrackingsService {
  fetchSeasonOptions(companyId: string, languageCode: string, isActive?: boolean): Promise<ICustomFieldOptions[]>;
  fetchOfficeOptions(companyId: string, isBlocked?: boolean): Promise<ICustomFieldOptions[]>;
  exportToExcel(reportsToDownloadDataManager: DataManager, query: Query, filters: IMyRule): Promise<any>;
}

class TrackingsService implements ITrackingsService {
  private cacheReportStates: any[];

  public constructor(private httpClient: services.IHttpClient) {

  }

  public async exportToExcel(reportsToDownloadDataManager: DataManager, query: Query, filters: IMyRule): Promise<any> {
    const queryWithFilters = queryBuilderService.buildQuery(reportsToDownloadDataManager, filters, query);

    const response = await oDataService.executeQueryWithCount<IFile>(reportsToDownloadDataManager, queryWithFilters);

    return response;
  }

  public async fetchSeasonOptions(companyId: string, languageCode: string, isActive?: boolean): Promise<ICustomFieldOptions[]> {
    try {
      const seasonResponse = await this.httpClient.getCustom<{ content: string }>(`${URL.WEB.BASE}${URL.WEB.TRACKINGS}/seasons?companyId=${companyId}&languageCode=${languageCode}&isActive=${isActive}`);
      const content = JSON.parse(seasonResponse.content) as Record<string, string>;

      return Object.entries(content).map(([id, name]) => ({ id, name }));
    } catch (error) {
      return [];
    }
  }

  public async fetchOfficeOptions(companyId: string, isBlocked?: boolean): Promise<ICustomFieldOptions[]> {
    try {
      const officesResponse = await this.httpClient.getCustom<{ content: string }>(`${URL.WEB.BASE}${URL.WEB.TRACKINGS}/offices?companyId=${companyId}&isBlocked=${isBlocked}`);
      const content = JSON.parse(officesResponse.content) as Record<string, string>;

      return Object.entries(content).map(([id, name]) => ({ id, name }));
    } catch (error) {
      return [];
    }
  }
}

export const trackingsService = new TrackingsService(services.httpClient);
